import {Injectable} from '@angular/core';
import {handleResult} from "@share/utils/handle-result";
import {Result} from "@domain/common/http/result";
import {FormulaireHttpService} from "@services/admin/parametre/formulaire/formulaire-http.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastrService} from "ngx-toastr";
import {ParamOmp} from "@domain/admin/parametre/formulaire/param-omp";
import {finalize} from "rxjs/operators";

/**
 * Service du formulaire OMP
 *
 * @author Lionel Gimenez
 * @date 04/09/2025
 */
@Injectable()
export class FormulaireOmpService {
    /** Indicateur pour savoir si on est en cours de sauvegarde */
    isSaving: boolean = false;

    /** Paramètres OMP */
    paramOmp: ParamOmp;

    /**
     * Constructeur
     */
    constructor(
        private formulaireHttpService: FormulaireHttpService,
        private translateService: TranslateService,
        private toastrService: ToastrService
    ) {
    }

    /**
     * Charge les données
     */
    load(): void {
        this.formulaireHttpService.loadOmp()
            .pipe(handleResult(this.translateService,this.toastrService,null,'global.errors.generic'))
            .subscribe((result: Result) => {
                this.paramOmp = result.data.param;
            });
    }

    /**
     * Sauvegarde les données
     */
    save(): void {
        this.isSaving = true;

        this.formulaireHttpService.saveOmp(this.paramOmp)
            .pipe(
                handleResult(this.translateService,this.toastrService),
                finalize(() => this.isSaving = false))
            .subscribe((result: Result) => {
                //Refresh
                this.load();
            });
    }
}